import { computed, Inject, Injectable, PLATFORM_ID, signal } from '@angular/core';
import { CookieService } from '../cookie/cookie.service';
import { isPlatformBrowser } from '@angular/common';
import { Cookies, RecruiterPanelUrl } from '../../../shared/enums/app.enums';
import { redirectExternal } from '../../../shared/utils/functions';

@Injectable({
    providedIn: 'root'
})
export class AuthService {
    private isBrowser: boolean;
    private isAuthenticated = signal<boolean>(false);
    private isCorporate = signal<boolean>(false)
    public isAuthenticatedUser = computed(() => this.isAuthenticated());
    public isCorporateUSer = computed(() => this.isCorporate())

    constructor(
        @Inject(PLATFORM_ID) private platformId: Object,
        private cookieService: CookieService) {
        this.isBrowser = isPlatformBrowser(this.platformId);
        if (this.cookieService.getCookie(Cookies.MyBDJOBSUSERID)) {
            this.isAuthenticated.set(true);
        }
        if(this.cookieService.getCookie(Cookies.AUTH)){
            this.isCorporate.set(true)
        }
    }

    redirectToRecruiterApp() {
        if (this.isBrowser) {
            redirectExternal(RecruiterPanelUrl)
        }
    }
    
}